"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.is.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.keys.js");
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _index = _interopRequireDefault(require("@/store/index"));
var _auth = require("@/utils/auth");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  responseType: 'json',
  validateStatus: function validateStatus(status) {
    return status === 200;
  }
});
var refresh_service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  responseType: 'json',
  validateStatus: function validateStatus(status) {
    return status === 200;
  }
});
service.interceptors.request.use(function (config) {
  var _config = config;
  try {
    var expireTime = (0, _auth.getExpireTime)();
    if (expireTime) {
      var left = expireTime - new Date().getTime();
      var refreshToken = (0, _auth.getRefreshToken)();
      if (left < 5 * 60 * 1000 && refreshToken) {
        _config = queryRefreshToken(_config, refreshToken);
      } else {
        if ((0, _auth.getToken)()) {
          _config.headers['Authorization'] = 'bearer ' + (0, _auth.getToken)();
        }
      }
    }
  } catch (e) {
    console.error(e);
  }
  return _config;
}, function (error) {
  console.log(error);
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  if (error.response) {
    var errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message;
    switch (error.response.status) {
      case 404:
        (0, _elementUi.Message)({
          message: '很抱歉，资源未找到' || 'Error',
          type: 'error',
          duration: 5 * 1000
        });
        break;
      case 403:
        (0, _elementUi.Message)({
          message: '很抱歉，您暂无该操作权限' || 'Error',
          type: 'error',
          duration: 5 * 1000
        });
        break;
      case 401:
        (0, _elementUi.Message)({
          message: '很抱歉，认证已失效，请重新登录' || 'Error',
          type: 'error',
          duration: 5 * 1000
        });
        break;
      default:
        if (errorMessage) {
          (0, _elementUi.Message)({
            message: errorMessage,
            type: 'error',
            duration: 5 * 1000
          });
        }
        break;
    }
  }
  return Promise.reject(error);
});
var request = {
  refresh: function refresh(url, params) {
    params['grant_type'] = 'refresh_token';
    return refresh_service.post(url, params, {
      transformRequest: [function (params) {
        return tansParams(params);
      }],
      headers: {
        'Authorization': 'Basic ZmViczoxMjM0NTY='
      }
    });
  },
  login: function login(url, params) {
    params['grant_type'] = 'password';
    return service.post(url, params, {
      transformRequest: [function (params) {
        return tansParams(params);
      }],
      headers: {
        'Authorization': 'Basic ZmViczoxMjM0NTY='
      }
    });
  },
  post: function post(url, params) {
    return service.post(url, params, {
      transformRequest: [function (params) {
        return tansParams(params);
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  put: function put(url, params) {
    return service.put(url, params, {
      transformRequest: [function (params) {
        return tansParams(params);
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  get: function get(url, params) {
    var _params;
    if (Object.is(params, undefined)) {
      _params = '';
    } else {
      _params = '?';
      for (var key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += "".concat(key, "=").concat(params[key], "&");
        }
      }
    }
    return service.get("".concat(url).concat(_params));
  },
  delete: function _delete(url, params) {
    var _params;
    if (Object.is(params, undefined)) {
      _params = '';
    } else {
      _params = '?';
      for (var key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += "".concat(key, "=").concat(params[key], "&");
        }
      }
    }
    return service.delete("".concat(url).concat(_params));
  },
  download: function download(url, params, filename) {
    _nprogress.default.start();
    return service.post(url, params, {
      transformRequest: [function (params) {
        return tansParams(params);
      }],
      responseType: 'blob'
    }).then(function (r) {
      var content = r.data;
      var blob = new Blob([content]);
      if ('download' in document.createElement('a')) {
        var elink = document.createElement('a');
        elink.download = filename;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        navigator.msSaveBlob(blob, filename);
      }
      _nprogress.default.done();
    }).catch(function (r) {
      console.error(r);
      _nprogress.default.done();
      (0, _elementUi.Message)({
        message: '下载失败',
        type: 'error',
        duration: 5 * 1000
      });
    });
  },
  upload: function upload(url, params) {
    return service.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
function tansParams(params) {
  var result = '';
  Object.keys(params).forEach(function (key) {
    if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
      result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
    }
  });
  return result;
}
function queryRefreshToken(_x, _x2) {
  return _queryRefreshToken.apply(this, arguments);
}
function _queryRefreshToken() {
  _queryRefreshToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(config, refreshToken) {
    var result;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request.refresh('anno/login', {
            // const result = await request.refresh('auth/token', {
            refresh_token: refreshToken
          });
        case 2:
          result = _context.sent;
          if (result.status === 200) {
            saveData(result.data);
            config.headers['Authorization'] = 'bearer ' + (0, _auth.getToken)();
          }
          return _context.abrupt("return", config);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _queryRefreshToken.apply(this, arguments);
}
function saveData(data) {
  _index.default.commit('account/setAccessToken', data.access_token);
  _index.default.commit('account/setRefreshToken', data.refresh_token);
  var current = new Date();
  var expireTime = current.setTime(current.getTime() + 1000 * data.expires_in);
  _index.default.commit('account/setExpireTime', expireTime);
}
var _default = request;
exports.default = _default;